import { render, staticRenderFns } from "./yourAge.vue?vue&type=template&id=485686ec&scoped=true&"
import script from "./yourAge.vue?vue&type=script&lang=js&"
export * from "./yourAge.vue?vue&type=script&lang=js&"
import style0 from "./yourAge.vue?vue&type=style&index=0&id=485686ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485686ec",
  null
  
)

export default component.exports